// 📁 context/FormPageErrorsContext.js
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

const FormPageErrorsContext = createContext();

export function FormPageErrorsProvider({ children }) {
  const [errorMap, setErrorMap] = useState({}); // { [id]: true/false }

  const updateError = useCallback((id, hasError) => {
    setErrorMap((prev) => {
      if (prev[id] === hasError) return prev;
      return { ...prev, [id]: hasError };
    });
  }, []);

  const resetErrors = useCallback(() => {
    setErrorMap({});
  }, []);

  const hasAnyError = Object.values(errorMap).some(Boolean);

  const contextValue = useMemo(
    () => ({
      errorMap,
      updateError,
      resetErrors,
      hasAnyError,
    }),
    [errorMap, updateError, resetErrors, hasAnyError],
  );

  return (
    <FormPageErrorsContext.Provider value={contextValue}>
      {children}
    </FormPageErrorsContext.Provider>
  );
}

FormPageErrorsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useFormPageErrorsContext() {
  const context = useContext(FormPageErrorsContext);
  if (!context) {
    throw new Error(
      'useFormPageErrorsContext must be used within a FormPageErrorsProvider',
    );
  }
  return context;
}

// ✅ Hook جاهز للاستخدام في أي Accordion أو مكون داخلي
export function useFormPageErrors(id, hasError) {
  const { updateError } = useFormPageErrorsContext();

  React.useEffect(() => {
    updateError(id, hasError);
  }, [id, hasError, updateError]);
}
